import { GlobalStyles } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { PropsWithChildren } from 'react'

import RecaptchaGuard from '@/app/component/guard/recaptcha'

type Props = PropsWithChildren<{
  title?: string
  waitRecaptcha?: boolean
}>

/**
 * The default layout, will set the title of the page and apply some global styles.
 * Because it doesn't hide google recaptcha, any page that uses this layout will have a recaptcha badge.
 */
const RecaptchaLayout: React.FC<Props> = ({ title = 'engageSPARK', children, waitRecaptcha = true }) => {
  React.useEffect(() => {
    window.document.title = title
  }, [title])

  if (waitRecaptcha) {
    return (
      <Page>
        <RecaptchaGuard>
          <GlobalStyles styles={globalStyles} />
          {children}
        </RecaptchaGuard>
      </Page>
    )
  }

  return (
    <Page>
      <GlobalStyles styles={globalStyles} />
      {children}
    </Page>
  )
}

const Page = styled('div')({
  minWidth: '100%',
  overflow: 'hidden',
})

const globalStyles = {
  html: {
    height: '100%',
    width: '100%',
  },
  body: {
    height: '100%',
    overflowX: 'auto',
    boxSizing: 'content-box',
  },
  'body *': {
    boxSizing: 'border-box',
  },
  form: {
    marginBottom: 0,
  },
}

export default RecaptchaLayout
